import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Textarea,
  useDisclosure,
} from "@chakra-ui/react";
import BookingDataService from "../../services/Booking";
function CorporateBannerModal({ isOpen, onClose }: any) {
  const token = localStorage.getItem("logged_in_user_token");
  //   const { isOpen, onClose } = useDisclosure();
  const [textValue, setTextValue] = useState("");

  const handleSave = () => {
    BookingDataService.updateCorporatesDetails(
      "66d55f4365cd4b587f5066ce",
      token,
      { information_banner_text: textValue }
    );
    setTextValue("")
    onClose();
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Enter Information</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Textarea
              value={textValue}
              onChange={(e) => setTextValue(e.target.value)}
              placeholder="Enter your text here..."
              size="sm"
            />
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={handleSave}>
              Save
            </Button>
            <Button variant="ghost" onClick={onClose}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default CorporateBannerModal;
